import {
  Image as ChakraImage,
  ImageProps as ChakraImageProps,
} from '@chakra-ui/react';

import { Loader } from 'shared';

import { useHEICImage } from 'shared/hooks/query/useHEICImage';

interface ImageProps extends Omit<ChakraImageProps, 'src'> {
  src: string;
  contentType?: string;
  fallbackBackground?: string;
}

export const Image = ({
  src,
  contentType = 'image/jpeg',
  fallbackBackground = 'transparent',
  ...rest
}: ImageProps) => {
  const { data: imageSrc = src, isLoading } = useHEICImage({
    src,
    contentType,
  });

  if (isLoading) {
    return <Loader data-testid="image-loader" />;
  }

  return <ChakraImage src={imageSrc} {...rest} />;
};
